import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from 'src/app/models/category';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: 'root'
})
export class CategoryService {


	constructor(private http: HttpClient,
    ) { }
	url = environment.serverAPI4 + "/api/category";

	url1 = environment.serverAPI4 + "/api";

	getCategoryBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	categoryLists(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/idx/all?page=${Page}&size=${size}&sort=${sort}`);
	}

	categoryListWithoutPagination(): Observable<Object> {
		return this.http.get(`${this.url}/idx/withoutPagination`);
	}

	categoryById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/idx1/${id}`);
	}
	createCategory(category: Category): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, category);
	}


	categoryList(): Observable<Object> {
		return this.http.get(`${this.url}/idx/nested/all`);
	}

	pageList(): Observable<Object> {
		return this.http.get(`${this.url}/idx/nested/all/pages`);
	}

	categoryListWithoutInActiveCategory(): Observable<Object> {
		return this.http.get(`${this.url}/idx/nested/all/withoutInActive`);
	}


	categoryNameVerified(categoryName: any): Observable<Object> {
		return this.http.get(`${this.url1}/categoryNameExists/${categoryName}`);
	}


  fetchCategoryData(id: any): Observable<Object> {
		return this.http.get(`${this.url}/breadCrump/${id}`);
	}

  deleteCategoryById(id: number): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

}

